const syncUpdateReason = {
	name: 'Update',
	fields: {
		sync_module: 'Module',
		sync_entity_id: 'ERP no.',
		entity: 'Record',
		changed_columns: 'Changed fields',
		changed_at: 'Time',
	},
}

export default syncUpdateReason
